import React, { useContext } from "react";

import Paper from "@/components/paper/Paper";
// import { ContactsProps } from "@/interfaces/CompanyProfile"
import { checkSupression, checkLinkSupression } from "@/utils/index";
import { useTranslation } from "react-i18next";
import { AppContext, ContextType } from "@/shared/context";

const Contacts = ({props}): JSX.Element => {
  const {
    showComponentInfo,
    contacts,
    contactHeading,
    // contactDescription,
    cta,
  } = props;
  const {t} = useTranslation();
  const { isUnitedStates, isEuBd } = useContext(AppContext) as ContextType;


  if (!showComponentInfo)  return <></>

  const getCount = () => {
    return contactHeading?.split(">")?.[1].split("<")?.[0];
  }

  const getContactName = (value: string): string => {
    return value.replace("Contact", t("companyProfile.contacts.contact"))
  }

  const getContactCount = () => {
    // return contactHeading?.split(">")?.[3].split("<")?.[0];
  }

  return (
    <div className="contacts-header" module_name="contact_list">
      <a className="anchor" data-name="contact-anchor" href="/contact-anchor" id="contact-list">
        <span className="display-hidden">Contacts</span>
      </a>
      <Paper title={t("companyProfile.contacts.headingText")}>
        <>
          <div className="contacts-heading mt-4">
            <span>{t("companyProfile.contacts.descriptionPrefix")}</span>
            <span className="principal-count">
              {isEuBd ? getCount(): ''}
              {isUnitedStates ? props.totalPrincipals: ''}
            </span>
            {isUnitedStates && 
              <span>{(parseInt(props.totalContacts) === 0) ? 
                `${t("companyProfile.contacts.descriptionMidPart").replace(/\s+and\s+/,"")}` :
                `${t("companyProfile.contacts.descriptionMidPart")}`
              }
              {(parseInt(props.totalContacts) !== 0) && <span className="principal-count">{isUnitedStates ? props.totalContacts: ''}</span>}
              </span>
            }
            {(parseInt(props.totalContacts) !== 0) && <span>{t("companyProfile.contacts.descriptionSuffix")}</span>}
            {/* {<span dangerouslySetInnerHTML={{ "__html":  }}/>} */}
          </div>
          {/* {contactDescription && (
            <div className="contacts-description">
              {contactDescription}
            </div>
          )} */}
          <div className="contacts-body">
            {/* <sly data-sly-use.template="templates/contact_list.html" data-sly-call="{template.contacts @contacts=model.contacts}" /> */}
            <ul>
              {contacts.map((contact, i) => (
                <li key={`contact-${i}`} className="employee" itemProp="employee" itemScope="" itemType="https://schema.org/Person">
                  {contact.profileLink && checkLinkSupression(contact.profileLink) ? (
                    <a href={contact.profileLink} className="contact-link">
                      <div className="name" itemProp="name" data-tracking-name="Contacts">{contact.name}</div>
                      <div className="position sub" itemProp="jobTitle" data-tracking-name="Contacts">{contact.position}</div>
                    </a>
                  ) : (
                    <>
                      <div className="name" itemProp="name" data-tracking-name="Contacts">
                        {getContactName(contact.name)}
                      </div>
                      <div className="position sub" itemProp="jobTitle" data-tracking-name="Contacts">
                        {checkSupression(contact.position)}
                      </div>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div className="contacts-cta d-print-none">
            {/* <sly data-sly-use.template="templates/cta.html" data-sly-call="{template.cta @cta=model.cta}" /> */}
            <a
              href={t("companyProfile.contacts.buttonLink")}
              aria-label={cta?.type === "text" ? cta?.label : cta?.altText}
              className="button-primary ext-icon"
              rel="noreferrer"
              //  onClick="${cta.tracking @ context='html'}"
              target={cta?.newTab ? '_blank' : '_self'}
            >
              {cta?.type === "text" ? t("companyProfile.contacts.buttonLabel") : 
                <img src={cta?.srcUrl} alt={cta?.altText} />
              }
            </a>
          </div>
        </>
      </Paper>
    </div>
  )
}

export default Contacts